module.exports = __webpack_public_path__ + "static/media/stbLogo.d4245663.png";